var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.noDataSelectItem},[_vm._t("default",function(){return [_vm._v("No such data")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }